import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { Formulaire } from '../model/formulaire';
import { FormulaireDTO } from '../model/formulaire-dto';
import { FormIsValidDTO } from '../model/form-is-valid-dto';

@Injectable({
    providedIn: 'root'
  })
  export class FormulaireService{
  

    constructor(private _restClientService : RestClientService) 
    {}
    
    getAllFormulaires() 
    {
      return this._restClientService.load<Formulaire[]>('formulaire/get');
    }
    
    add(formulaire) {
      return  this._restClientService.save<Formulaire>('formulaire/add', formulaire);
    }
  
    update(formulaire) {
      return  this._restClientService.put<Formulaire>(`formulaire/update`, formulaire);
    }
      
    getFormulaireById(formulaireId)
    {
      return this._restClientService.load<Formulaire>('formulaire/get/'+formulaireId);
    }

    takeFormInfoRequest(requestId) 
    {
      return this._restClientService.load<FormulaireDTO>('formulaire/take-form-info-request?requestid='+requestId);
    }
    
    takeFormUpdateRequest(correctionId) 
    {
      return this._restClientService.load<FormulaireDTO>('formulaire/take-form-update-request?correctionid='+correctionId);
    }
    
    takeFormExecutionTask(taskId) 
    {
      return this._restClientService.load<Formulaire>('formulaire/take-form-execution-task?taskid='+taskId);
    }
    
    checkForm(taskId) 
    {
      return this._restClientService.load<FormIsValidDTO>('formulaire/check-form?taskId='+taskId);
    }
    
  
}      

    